import React, { useRef, useState, useEffect } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import { ToastContainer, toast } from 'react-toastify';  // Importing Toastify
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS
import { trackContactFormStart, trackContactFormSubmit, trackSectionView } from '../utils/mixpanel';

function Contact() {
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const [nameError, setNameError] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);

  const form = useRef<HTMLFormElement>(null);

  const [formStarted, setFormStarted] = useState(false);

  // Track section view when component mounts
  useEffect(() => {
    trackSectionView('contact');
  }, []);

  // Track when user starts filling the form (only once)
  useEffect(() => {
    if ((name || email || message) && !formStarted) {
      trackContactFormStart();
      setFormStarted(true);
    }
  }, [name, email, message, formStarted]);

  const sendEmail = (e: any) => {
    e.preventDefault();

    setNameError(name === '');
    setEmailError(email === '');
    setMessageError(message === '');

    if (name !== '' && email !== '' && message !== '') {
      var templateParams = {
        name: name,
        email: email,
        message: message,
      };

      emailjs.send('service_husrywz', 'template_m05qyrg', templateParams, 'CHODXPDyqrKy_7-v6').then(
        (response) => {
          toast.success('Thank you for reaching out! Your message has been successfully submitted.');
          trackContactFormSubmit(true);
          setName('');
          setEmail('');
          setMessage('');
        },
        (error) => {
          toast.error('Something went wrong. Please try again.');
          trackContactFormSubmit(false, error.text || 'Unknown error');
        }
      );
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Me</h1>
          <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>
          <Card
            ref={form}
            component="form"
            noValidate
            autoComplete="off"
            className="contact-form"
            sx={{ padding: 3 }}
          >
            <div className="form-flex">
              <TextField
                required
                label="Your Name"
                placeholder="What's your name?"
                value={name}
                onChange={(e) => setName(e.target.value)}
                error={nameError}
                helperText={nameError ? "Please enter your name" : ""}
                sx={{ marginBottom: 2 }}
              />
              <TextField
                required
                label="Email / Phone"
                placeholder="How can I reach you?"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={emailError}
                helperText={emailError ? "Please enter your email or phone number" : ""}
                sx={{ marginBottom: 2 }}
              />
            </div>
            <TextField
              required
              label="Message"
              placeholder="Send me any inquiries or questions"
              multiline
              rows={10}
              className="body-form"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              error={messageError}
              helperText={messageError ? "Please enter the message" : ""}
              sx={{ marginBottom: 2 }}
            />
            <Button
              variant="contained"
              endIcon={<SendIcon />}
              onClick={sendEmail}
              sx={{ marginTop: 2 }}
            >
              Send
            </Button>
          </Card>
        </div>
      </div>

      {/* ToastContainer will hold the Toast messages */}
      <ToastContainer 
        position="bottom-right" 
        autoClose={6000} 
        hideProgressBar={true} 
        closeOnClick 
        pauseOnHover 
        draggable
      />
    </div>
  );
}

export default Contact;